module.exports = __webpack_public_path__ + "static/img/AG@2x.95945b7a.jpg";